import React from 'react';
import { getCloudId } from '@helpcenter/meta';
import { di } from 'react-magnetic-di';
import { getHelpCenterId } from 'utils/ari-parser';
import { useRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { HubHomeContent } from '@atlassian/hub-home';
import { useHelpCenterAri } from '../../hooks/use-help-center-ari';
import { AdminManagementLayout } from '../admin-management-layout';
import { EditLayoutResource } from './resources/edit-layout/resource';

export const HubEditLayout = () => {
    di(useRelayResource, EditLayoutResource);
    const { queryReference } = useRelayResource(EditLayoutResource);
    const helpCenterAri = useHelpCenterAri();
    if (!queryReference) return null;

    const cloudId = getCloudId();
    const hubId = getHelpCenterId(helpCenterAri || '');
    return (
        <AdminManagementLayout featureName="Helpcenter hub edit" hideSidebar>
            <HubHomeContent
                cloudId={cloudId}
                hubAri={helpCenterAri}
                hubId={hubId}
                pageId={hubId}
                queryReference={queryReference}
            />
        </AdminManagementLayout>
    );
};
